import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import firebase from "../../services/FirebaseService";

import Navbar from "../../components/Navbar";

import "../../assets/style/admin/admin-chat.css";

const ChatBox = ({ id }) => {

	const [ messages, setMessages ] = useState([]);
	const [ loading, setLoading ] = useState(true);
	const [ message, setMessage ] = useState("");

	useEffect(() => {
		firebase.firestore().collection("chats").doc(id).collection("messages").orderBy("createdAt", "desc").onSnapshot(snapshot => {
			const array = snapshot.docs.map(doc => doc.data());
			setMessages(array);

		});
	
		setLoading(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleSubmit = async event => {
		event.preventDefault();

		setLoading(true);
		
		if (message.length > 0) {
			
			try {
				const doc = await firebase.firestore().collection("chats").doc(id).get();


				doc.ref.collection("messages").add({
					service: true, 
					content: message,
					createdAt: firebase.firestore.FieldValue.serverTimestamp() 
				});
				setMessage("");
				
				setLoading(false);
				
			}
			catch(error) {
				console.log(error);
			}
				
			
		}
	}

	return (
		<>
			<section id="chatbox">
				{ !loading && messages.map((message) => (	
					<div className={message.service ? "message service" : "message"}>
						<div>{message.content}</div>
					</div>
				)) }
			</section>
			<form onSubmit={e => handleSubmit(e)}>
				<input 
					name="message"
					type="text"	
					placeholder="Enter a message..."
					disabled={loading}
					autoComplete="off"
					value={message}
					onChange={event => setMessage(event.target.value)}
				></input>
				<button
					disabled={loading}
				>Send</button>
			</form>
		</>
	)
}

const GroupContainer = ({ id }) => (
	<section id="admin-chat-showcase">
		<ChatBox id={id} />
	</section>
);

const AdminChatPage = ({ match }) => (
	<>
		<Navbar />
		{ match.params.id ? <GroupContainer id={match.params.id} /> : <Redirect to="/" /> }
	</>
);

export default AdminChatPage;